export interface DeviceProfile {
  id: string;
  label: string;
  hostname: string;
  model: string;
  memory: string;
  disk: {
    label: string;
    size: string;
    match: {
      key: 'serial' | 'path' | 'id_path';
      value: string;
    };
  };
  wifi: {
    interfaceName: string;
    adapter: string;
  };
  sshPublicKey: string;
}

export const deviceProfiles: DeviceProfile[] = [
  {
    id: 'shud-laptop-1',
    label: 'Shud · Laptop 1',
    hostname: 'shud-laptop-1',
    model: 'ThinkPad T14s Gen 1',
    memory: '32 GB',
    disk: {
      label: 'NVMe interno 1 TB',
      size: '953,9 GB',
      match: {
        key: 'path',
        value: '/dev/nvme0n1',
      },
    },
    wifi: {
      interfaceName: 'wlp0s20f3',
      adapter: 'Intel Wi-Fi 6 AX201',
    },
    sshPublicKey:
      'ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIIeMpnwz2ltMsiatEEPg3puR5MJO01e0BpCybFodHIql',
  },
];

export function findDeviceProfile(id: string): DeviceProfile {
  const profile = deviceProfiles.find((candidate) => candidate.id === id);

  if (!profile) {
    throw new Error(`Perfil de dispositivo desconhecido: ${id}`);
  }

  return profile;
}
